'use client';

import { useEffect, useState } from 'react';
import { c } from '../../../utils/tailwind-merge';
import { ProductRating } from '../ProductRating';
import { ProductReviews } from '../ProductReviews';
import { ReviewListProps } from './ReviewList.types';

export const ReviewList = ({
  microcopy,
  className,
  reviewStars,
  reviewList,
  canWriteReview,
  onFilterReviews,
  onEditReply,
  onDeleteReply,
  onEditReview,
  onSubmitReport,
  onSubmitReply,
  onSort,
  onPageChange,
  onFilter,
  onHelpfulVotesReview,
  onHelpfulVotesReply,
  onSubmitReview,
  onEmailPublisher,
  onDeleteReview,
  reviews,
  ownedDate,
  start,
  end,
  total,
  currentPage,
  totalPages,
  writeReviewModal,
  activeFilterValue,
}: ReviewListProps) => {
  const [reviewsOnLoad, setReviewsOnLoad] = useState(reviews);

  useEffect(() => {
    setReviewsOnLoad(reviews);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className={c(className)}>
      {reviewsOnLoad.length ? (
        <ProductRating
          reviewList={reviewList}
          reviewStars={reviewStars}
          canWriteReview={canWriteReview}
          writeReviewModal={writeReviewModal}
          onFilterReviews={onFilterReviews}
          onSubmitReview={onSubmitReview}
          onEmailPublisher={onEmailPublisher}
          microcopy={{
            ...microcopy.productRating,
          }}
          ownedDate={ownedDate}
          className="mb-8"
        />
      ) : null}

      <ProductReviews
        microcopy={microcopy.productReviews}
        writeReviewModal={writeReviewModal}
        reviews={reviews}
        activeFilterValue={activeFilterValue}
        start={start}
        end={end}
        total={total}
        currentPage={currentPage}
        totalPages={totalPages}
        reviewsOnLoad={reviewsOnLoad}
        onHelpfulVotesReview={onHelpfulVotesReview}
        onEditReview={onEditReview}
        onHelpfulVotesReply={onHelpfulVotesReply}
        onEditReply={onEditReply}
        onDeleteReply={onDeleteReply}
        onSubmitReply={onSubmitReply}
        onFilter={onFilter}
        onSort={onSort}
        onPageChange={onPageChange}
        onSubmitReport={onSubmitReport}
        onEmailPublisher={onEmailPublisher}
        onSubmitReview={onSubmitReview}
        onDeleteReview={onDeleteReview}
      />
    </section>
  );
};
